import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { ModuleHeader } from '@/components/ui/module-header';
import { DataTable } from '@/components/ui/data-table';
import { Card, CardContent } from '@/components/ui/card';
import { StatusPill } from '@/components/ui/status-pill';
import { api } from '@/lib/api';

export default function SuperBillingPage() {
  const q = useQuery({
    queryKey: ['super-billing'],
    queryFn: async () => {
      const r = await api('/api/v1/super/billing');
      if (r.status !== 200) throw new Error('billing');
      return r.data.billing ?? [];
    },
  });

  const columns = useMemo(
    () => [
      { key: 'name', label: 'Company', sortable: true },
      { key: 'plan', label: 'Plan' },
      {
        key: 'billingStatus',
        label: 'Status',
        render: (v) => <StatusPill status={v} />,
      },
      {
        key: 'stripeCustomerId',
        label: 'Stripe customer',
        render: (v) => String(v ?? '—'),
        className: 'font-mono text-xs',
      },
      {
        key: 'stripeSubscriptionId',
        label: 'Subscription',
        render: (v) => String(v ?? '—'),
        className: 'font-mono text-xs',
      },
    ],
    []
  );

  return (
<div className="space-y-6 motion-enter">
        <ModuleHeader
          title="Billing"
          description="Real plan and Stripe linkage per tenant (no secret keys exposed)."
          icon="CreditCard"
          metrics={[{ label: 'Tenants', value: q.data?.length ?? 0 }]}
        />
        <Card>
          <CardContent className="pt-6">
            <DataTable columns={columns} data={q.data ?? []} emptyMessage="No companies" />
          </CardContent>
        </Card>
      </div>
);
}
